import React from 'react'
import { SortConfig } from '../pages/Products/utils/ordenamientos'

export const useSortableData = (items: any, config = null) => {
  const [sortConfig, setSortConfig] = React.useState<SortConfig | null>(config)

  const sortedItems = React.useMemo(() => {
    const sortableItems = [...items]
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1
        }
        return 0
      })
    }
    return sortableItems
  }, [items, sortConfig])

  const requestSort = (key: string, direction?: string) => {
    if (direction) {
      setSortConfig({ key, direction })
    } else {
      let direction = 'ascending'
      if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending'
      }
      setSortConfig({ key, direction })
    }
  }

  return { items: sortedItems, requestSort, sortConfig, setSortConfig }
}
